"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../config");
function default_1(dateSync, optimizePosition, player, streamOffset, delay, rememberedPosition) {
    var realFuturePosition = Math.floor(streamOffset + (player.getCurrentPosition() - rememberedPosition) * 1000);
    var delta = Math.floor(optimizePosition - realFuturePosition);
    var defaultResult = { speed: 1, delta: delta };
    if (Math.abs(delta) < config_1.default.minDelta) {
        return defaultResult;
    }
    var result = (realFuturePosition + config_1.default.maxDelta + delta) / (realFuturePosition + config_1.default.maxDelta);
    var correctSpeed = Math.abs(delta) < config_1.default.maxDelta ? Math.abs(delta) / 4000 : 0;
    if (delta < 0) {
        if (Math.abs(delta) > config_1.default.maxDelta) {
            var position = (optimizePosition - streamOffset) / 1000;
            if (position > 0)
                player.fastSeekToPosition(Math.abs(position));
            return defaultResult;
        }
        var speed = result - correctSpeed;
        return { speed: speed, delta: delta };
    }
    else if (delta > 0) {
        if (delta > config_1.default.maxDelta) {
            var position = (optimizePosition - streamOffset) / 1000;
            if (position > 0)
                player.fastSeekToPosition(Math.abs(position));
            return defaultResult;
        }
        var speed = result + correctSpeed;
        return { speed: speed, delta: delta };
    }
    return defaultResult;
}
exports.default = default_1;
//# sourceMappingURL=calculatePlaybackProgramDate.js.map